<template>
  <div>
    <div class="video-container">
      <div class="video-player">
        <div v-if="loading" class="d-flex align-center progessbar-container">
          <v-progress-linear
            color="red accent-4"
            indeterminate
            rounded
            height="6"
            style="width:50%;"
            class="progressbar"
          ></v-progress-linear>

          <!-- <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular> 
          <h2 class="red--text">로딩</h2>
          -->
        </div>
        <VideoJsComponent
          v-if="!loading && whatPlayer == 'video'"
          :collectionId="collectionId"
        ></VideoJsComponent>
        <VimeoComponent
          v-if="!loading && whatPlayer == 'vimeo'"
          :collectionId="collectionId"
        ></VimeoComponent>
        <YoutubeComponent
          v-if="!loading && whatPlayer == 'youtube'"
          :collectionId="collectionId"
        ></YoutubeComponent>
      </div>
    </div>
  </div>
</template>

<script>
import VideoJsComponent from "../components/VideoJsComponent.vue";
import VimeoComponent from "../components/VimeoComponent.vue";
import YoutubeComponent from "../components/YoutubeComponent.vue";

import { mapState } from "vuex";

export default {
  data: function() {
    return {
      loading: true,
      youtubePattern: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/,
      vimeoPattern: /(?:http:|https:|)\/\/(?:player.|www.)?vimeo\.com\/(?:video\/|embed\/|watch\?\S*v=|v\/)?(\d*)/
    };
  },
  computed: {
    ...mapState([
      "content",
      "contentId",
      "channel",
      "channelId",
      "collection",
      "collectionId",
      "user",
      "referer",
      "keyPass"
    ]),
    whatPlayer: function() {
      const isYoutube = this.youtubePattern.test(this.content.stream_url);
      const isVimeo = this.vimeoPattern.test(this.content.stream_url);
      if (isYoutube) return "youtube";
      if (isVimeo) return "vimeo";
      console.log({ isYoutube, isVimeo });
      return "video";
    }
  },
  components: {
    VideoJsComponent,
    VimeoComponent,
    YoutubeComponent
  },
  mounted: async function() {
    console.log("[VideoCollection] Mounted");
    console.log("[init 시작]");
    const _s = Date.now();

    // 입력값 세팅
    const contentId = this.$route.params.id;
    const collectionId = this.$route.params.collectionId;
    const timeLimit = this.$route.params.timeLimit
      ? decodeURIComponent(this.$route.params.timeLimit)
      : "";

    console.log({ contentId, collectionId, timeLimit });

    // 로딩 시작
    this.loading = true;

    // 컨텐트, 컬렉션 아이디, 타임리밋 검증
    const patt = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    const isContentId = patt.test(contentId);
    const isCollectionId = patt.test(collectionId);

    if (!isContentId || !isCollectionId) {
      this.$router.push({ name: "Error404" });
    }

    // 레퍼러 추출
    console.log({ "referer:": document.referrer });
    if (document.referrer) {
      const domain = document.referrer.split("/")[2];
      this.$store.commit("SET_REFERER", domain);
    }
    // this.$store.commit("SET_REFERER", document.referrer);
    // console.log({ "Referer:": document.referrer });

    // ip 정보추출 - 안할 수 있음 하지 말자.
    // const axiosIp = this.$axios.create({
    //   baseURL: "https://api.ipify.org",
    //   timeout: 10000
    // });
    // try {
    //   const ipaddr = await axiosIp.get("/");
    //   if (ipaddr) {
    //     const ip = ipaddr.data;
    //     this.$store.commit("SET_IP", ip);
    //     console.log("SET_IP", ip);
    //   }
    // } catch (e) {
    //   console.log(e);
    // }

    // 컨텐츠 정보 가져오기, ip도 여기서 처리
    await this.$store.dispatch("getContent", contentId);
    await this.$store.dispatch("getCollection", collectionId);

    // 라이센스 체크
    let isLicense = false;
    let basicId;
    const licenses = this.channel.licenses;
    // 기본 라이센스가 있는가?
    isLicense = licenses.some(lic => {
      const n = this.$moment().valueOf();
      const s = this.$moment(lic.start).valueOf();
      const e = this.$moment(lic.end).valueOf();
      if (s <= n && n <= e && lic.mode == "basic") {
        basicId = lic.id;
        return true;
      }
      return false;
    });

    console.log("[VideoCollection] 라이센스 체크", { licenses, isLicense });
    if (!isLicense) {
      this.$store.commit("SET_CHANNEL_ID", null);
      this.$store.commit("SET_CHANNEL", null);
      this.$store.commit("SET_CONTENT", null);
      this.$store.dispatch("signOutWithOutMoving");
      this.$router.push({ name: "ErrorLicense" });
    }
    // 라이센스로 부터 api 라이센스 도메인 목록 확보
    let apiDomains = [];
    licenses.forEach(lic => {
      if (lic.basic_id == basicId && lic.mode == "api")
        apiDomains.push(lic.domain);
    });

    // where체크 (domain/anywhere - referer)
    const where = this.collection ? this.collection.where : "";
    const domains = this.collection ? this.collection.where_domains : [];
    domains.push("onseminar.com");
    apiDomains.forEach(item => {
      domains.push(item);
    });

    if (where == "domain") {
      const referer = this.$store.state.referer;
      const pass = domains.some(domain => {
        let domainForCheck = domain;
        if (domain.includes("*.")) domainForCheck = domain.replace("*.", "");
        return (
          referer &&
          (referer == domainForCheck || referer.includes("." + domainForCheck))
        );
      });
      console.log("where 체크", { where, domains, pass });
      if (!pass) {
        this.$router.push({
          name: "Error403",
          params: { code: "where" }
        });
      }
    }

    // when 체크
    const when = this.collection ? this.collection.when : "";
    const start = this.collection ? this.collection.when_start : "";
    const end = this.collection ? this.collection.when_end : "";
    if (when == "schedule") {
      const s = this.$moment(start);
      const e = this.$moment(end);
      const n = this.$moment();
      console.log("when 체크", { s, n, e }, n.isAfter(s), n.isBefore(e));
      if (!n.isAfter(s) || !n.isBefore(e)) {
        this.$router.push({
          name: "Error403",
          params: { code: "when" }
        });
      }
    }

    // 컬렉션을 기준으로 사용자 정보 세팅 (state에 user세팅)
    const who = this.collection ? this.collection.who : "";
    const who_groups = this.collection ? this.collection.who_groups : "";

    if (who == "anyone" || who == "key") {
      const storageUser = localStorage.getItem("userId");
      const storageAuthTime = localStorage.getItem("authTime");

      let userId, authTime;

      if (storageUser) {
        userId = storageUser;
      } else {
        userId = this.$short.generate();
        localStorage.setItem("userId", userId);
      }
      if (storageAuthTime) {
        authTime = storageAuthTime;
      } else {
        authTime = Math.floor(Date.now() / 1000);
        localStorage.setItem("authTime", authTime);
      }
      const user = {
        email: userId,
        authTime
      };

      this.$store.commit("SET_USER", user);
      console.log(user, this.$store.state.user);
    }

    if (who == "allowed" || who == "me") {
      try {
        const currentSession = await this.$Auth.currentSession(); // 없으면 여기서 에러
        console.log("없어서 에라");
        const idToken = currentSession.getIdToken().getJwtToken();
        const userInfo = {};
        if (idToken) {
          userInfo.email = this.$jwtDecode(idToken).email;
          userInfo.authTime = this.$jwtDecode(idToken).auth_time;
          // userInfo.idToken = idToken;
          this.$store.commit("SET_USER", userInfo);
        }
      } catch (e) {
        console.log("init중 사용자 없음");
      }
    }

    console.log("who", who, "==", this.$store.state.user);

    // 사용자 권한 체크
    if (who == "anyone") {
      console.log("[Privacy]] who == anyone");
    }

    if (who == "key") {
      // 컬렉션에서 키 점검을 마치고 들어왔다는 걸 어떻게 알지? 키를 암호화해서 넘길 수 있지만, 별로...
      // 사실 상  키패스는 anyone과 동일하게 취급
    }

    // 토큰 정보 추출 (who= me, allowed 일때만)
    let idToken;
    let idTokenDecoded;
    if (who == "me" || who == "allowed") {
      await this.$Auth
        .currentAuthenticatedUser()
        .then(currentUser => {
          idToken = currentUser.signInUserSession.idToken.jwtToken;
        })
        .catch(() => {
          console.log("[VideoCollection] No Current Authenticated User");
          this.$store.commit("SET_USER", null);
        });

      idTokenDecoded = idToken
        ? this.$jwtDecode(idToken)
        : { "cognito:groups": [] };
    }
    // 토큰정보로 부터 사용자 비교
    if (who == "allowed") {
      const expectedRoles = ["service#sa", `${this.channelId}#cm`];
      if (who_groups && Array.isArray(who_groups)) {
        who_groups.forEach(item => expectedRoles.push(item));
      }
      console.log("[Privacy] who == allowed, group", {
        who_groups,
        expectedRoles,
        idTokenDecoded
      });

      if (
        !Array.isArray(idTokenDecoded["cognito:groups"]) ||
        !idTokenDecoded["cognito:groups"].some(elem =>
          expectedRoles.includes(elem)
        )
      ) {
        console.log("[Privacy] allowd 권한없음", this.user, this.contentId);
        if (this.user) {
          this.$router.push({
            name: "Error403",
            params: { code: "who" }
          });
        } else {
          console.log("gate페이지로", this.contentId);
          this.$router.push({
            name: "Gate",
            params: { id: this.contentId }
          });
        }
      }
    }

    if (who == "me") {
      console.log("[Privacy] who == me");
      console.log(Array.isArray(idTokenDecoded["cognito:groups"]));
      console.log(idTokenDecoded["cognito:groups"]);
      const expectedRoles = ["service#sa", `${this.channelId}#cm`];
      if (
        !Array.isArray(idTokenDecoded["cognito:groups"]) ||
        !idTokenDecoded["cognito:groups"].some(elem =>
          expectedRoles.includes(elem)
        )
      ) {
        console.log("[Prviacy] me 권한없음", this.user);
        if (this.user) {
          this.$router.push({
            name: "Error403",
            params: { code: "who" }
          });
        } else {
          this.$router.push({
            name: "Gate",
            params: { id: this.contentId }
          });
        }
      }
    }

    // 타이틀 설정
    document.title = this.content.title;

    // 로딩 끝
    // await new Promise(r => setTimeout(r, 300000));
    this.loading = false;

    // 카운터 올리기 (await 안함)
    this.$store.dispatch("updateContentCounter");

    console.log("[init 완료]", Date.now() - _s);
  },

  beforeMount: function() {},
  async beforeDestroy() {
    await this.$store.dispatch("offline");
  },
  methods: {}
};
</script>
<style scoped>
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}
.video-player {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.progessbar-container {
  position: relative;
  /* border: solid 1px #fff; */
  height: 100%;
}
.progressbar {
  margin: 0 auto;
}
</style>
